import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import JobDetail from "./pages/JobDetail";
import CreateProfile from "./pages/CreateProfile";
import ViewProfile from "./pages/ViewProfile";
import EditProfile from "./pages/EditProfile";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

import Register from "./pages/Register";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import RecruiterLogin from "./pages/RecruiterLogin";
import RecruiterDashboard from "./pages/RecruiterDashboard";
import ApplicantTracking from "./pages/ApplicantTracking";

import MyApplications from "./pages/MyApplications";

import HRLogin from "./pages/HRLogin";
import HRDashboard from "./pages/HRDashboard";
import HRCandidateProfile from "./pages/HRCandidateProfile";

import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <Routes>

          {/* ============================= */}
          {/* Public Routes */}
          {/* ============================= */}

          <Route path="/" element={<Home />} />

          <Route path="/job/:id" element={<JobDetail />} />


          {/* ============================= */}
          {/* Job Seeker Routes */}
          {/* ============================= */}

          <Route path="/login" element={<Login />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="/register" element={<Register />} />

          <Route path="/create-profile" element={<CreateProfile />} />

          <Route path="/profile/:email" element={<ViewProfile />} />

          <Route path="/edit-profile/:email" element={<EditProfile />} />

          <Route path="/my-applications" element={<MyApplications />} />


          {/* ============================= */}
          {/* Admin Routes */}
          {/* ============================= */}

          <Route path="/admin/login" element={<AdminLogin />} />

          <Route path="/admin/dashboard" element={<AdminDashboard />} />


          {/* ============================= */}
          {/* Recruiter Routes */}
          {/* ============================= */}

          <Route path="/recruiter/login" element={<RecruiterLogin />} />

          <Route path="/recruiter/dashboard" element={<RecruiterDashboard />} />

          <Route path="/recruiter/applicants" element={<ApplicantTracking />} />


          {/* ============================= */}
          {/* Company HR Routes */}
          {/* ============================= */}

          <Route path="/hr/login" element={<HRLogin />} />

          <Route path="/hr/dashboard" element={<HRDashboard />} />

          <Route
            path="/hr/candidate/:id"
            element={<HRCandidateProfile />}
          />

        </Routes>

      </BrowserRouter>

      <Toaster />

    </div>
  );
}

export default App;